module.exports = __webpack_public_path__ + "img/yacht-2.5fc7ae6d.jpg";